import React from 'react';
import { Check, Star, CreditCard, Lock } from 'lucide-react';

const PaymentMethodCard = ({
  type,
  isSelected,
  onSelect,
  children,
}) => {
  const isPayPal = type === 'paypal';

  return (
    <div
      onClick={onSelect}
      className={`relative bg-white rounded-xl border-2 transition-all duration-200 cursor-pointer ${
        isSelected
          ? 'border-[#FF8C00] shadow-md'
          : 'border-gray-200 hover:border-gray-300'
      }`}
      data-testid={`payment-method-${type}`}
    >
      {/* Selected indicator */}
      {isSelected && (
        <div className="absolute -top-2 -right-2 w-6 h-6 bg-[#FF8C00] rounded-full flex items-center justify-center">
          <Check className="h-4 w-4 text-white" />
        </div>
      )}

      <div className="p-5">
        {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-3">
            {isPayPal ? (
              // PayPal Logo
              <div className="w-12 h-12 bg-[#003087] rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xs">Pay</span>
              </div>
            ) : (
              // Card Icon
              <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
                <CreditCard className="h-6 w-6 text-gray-600" />
              </div>
            )}
            <div>
              <h3 className="font-semibold text-black">
                {isPayPal ? 'PayPal' : 'Credit / Debit Card'}
              </h3>
              {isPayPal && (
                <div className="flex items-center gap-1 mt-0.5">
                  <Star className="h-3 w-3 text-[#FF8C00] fill-[#FF8C00]" />
                  <span className="text-xs text-[#FF8C00] font-medium">Recommended</span>
                </div>
              )}
            </div>
          </div>

          {/* Radio indicator */}
          <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${
            isSelected ? 'border-[#FF8C00] bg-[#FF8C00]' : 'border-gray-300'
          }`}>
            {isSelected && <div className="w-2 h-2 bg-white rounded-full" />}
          </div>
        </div>

        {/* Description */}
        <p className="text-sm text-gray-500 mb-3">
          {isPayPal
            ? 'Fast, secure payment with buyer protection.'
            : 'Secure card payment powered by Stripe.'}
        </p>

        {/* Card logos for Stripe */}
        {!isPayPal && (
          <div className="flex items-center gap-2">
            <div className="w-10 h-6 bg-[#1A1F71] rounded flex items-center justify-center">
              <span className="text-white text-[8px] font-bold">VISA</span>
            </div>
            <div className="w-10 h-6 bg-[#EB001B] rounded flex items-center justify-center relative overflow-hidden">
              <div className="absolute right-0 w-5 h-6 bg-[#F79E1B] rounded-l-full" />
            </div>
            <div className="w-10 h-6 bg-gray-100 rounded flex items-center justify-center">
              <span className="text-gray-600 text-[8px] font-bold">AMEX</span>
            </div>
          </div>
        )}

        {/* PayPal security badge */}
        {isPayPal && (
          <div className="flex items-center gap-1.5 text-gray-400">
            <Lock className="h-3 w-3" />
            <span className="text-xs">PayPal Buyer Protection</span>
          </div>
        )}

        {/* Expandable content for card form */}
        {children}
      </div>
    </div>
  );
};

export default PaymentMethodCard;
